export default __webpack_public_path__ + "static/media/almonds-image.f0e6119b.png";